import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showMessage } from 'store/slices/message.slice';

const useDispatchMessage = () => {
	const dispatch = useDispatch();

	return useCallback(
		({ message, variant = 'success' }) =>
			dispatch(
				showMessage({
					message,
					variant
				})
			),
		[dispatch]
	);
};

export default useDispatchMessage;
